import { Lightning, AppData } from '@lightningjs/sdk';
import { extractUrlFromText, convertAnchorTagsToBold } from 'support/textUtils';
import SettingsQrCodeSection from './SettingsQrCodeSection';
import QrCodeContent from './contents/QrCodeContent';

export interface PrivacyLegalSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Content: {
    TermsOfUseContent: typeof QrCodeContent;
    TermsOfUseQrCode: typeof SettingsQrCodeSection;
    PrivacyPolicyContent: typeof QrCodeContent;
    PrivacyPolicyQrCode: typeof SettingsQrCodeSection;
  };
}

const CONTENT_SPACING = 48;

export default class PrivacyLegalSection
  extends Lightning.Component<PrivacyLegalSectionTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<PrivacyLegalSectionTemplateSpec>
{
  private _Content = this.getByRef('Content')!;
  private _TermsOfUseContent = this._Content.getByRef('TermsOfUseContent')!;
  private _TermsOfUseQrCode = this._Content.getByRef('TermsOfUseQrCode')!;
  private _PrivacyPolicyContent = this._Content.getByRef(
    'PrivacyPolicyContent',
  )!;
  private _PrivacyPolicyQrCode = this._Content.getByRef('PrivacyPolicyQrCode')!;

  get title() {
    const touContent = this._TermsOfUseContent.title;
    const ppContent = this._PrivacyPolicyContent.title;

    return [...touContent, ...ppContent];
  }

  static override _template(): Lightning.Component.Template<PrivacyLegalSectionTemplateSpec> {
    return {
      Content: {
        flex: { direction: 'column' },
        TermsOfUseContent: { type: QrCodeContent },
        TermsOfUseQrCode: {
          flexItem: { marginBottom: CONTENT_SPACING },
          type: SettingsQrCodeSection,
        },
        PrivacyPolicyContent: { type: QrCodeContent },
        PrivacyPolicyQrCode: { type: SettingsQrCodeSection },
      },
    };
  }

  override _active() {
    const settingsContent = AppData!.config?.login.settings;
    if (!settingsContent) return;

    const rawTermsOfUseDescription =
      settingsContent.privacy_and_legal.terms_of_use.description ?? '';
    const rawPrivacyPolicyDescription =
      settingsContent.privacy_and_legal.privacy_policy.description ?? '';

    const termsOfUseHeading =
      settingsContent.privacy_and_legal.terms_of_use.title ?? '';
    const privacyPolicyHeading =
      settingsContent.privacy_and_legal.privacy_policy.title ?? '';

    const termsOfUseUrl = extractUrlFromText(rawTermsOfUseDescription);
    const privacyPolicyUrl = extractUrlFromText(rawPrivacyPolicyDescription);

    const termsOfUseDescription = convertAnchorTagsToBold(
      rawTermsOfUseDescription,
    );
    const privacyPolicyDescription = convertAnchorTagsToBold(
      rawPrivacyPolicyDescription,
    );

    this._TermsOfUseContent.heading = termsOfUseHeading;
    this._TermsOfUseContent.description = termsOfUseDescription;
    this._TermsOfUseQrCode.url = termsOfUseUrl;

    this._PrivacyPolicyContent.heading = privacyPolicyHeading;
    this._PrivacyPolicyContent.description = privacyPolicyDescription;
    this._PrivacyPolicyQrCode.url = privacyPolicyUrl;
  }
}
